import { useEffect, useState } from 'react';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { httpGet } from '../../../../components/utils';
import jstz from 'jstimezonedetect';
import { ActivityEntity } from '../types/Insights';
import { HttpResponse } from '../../../../api/types/Http';

interface Params {
    domainName: string[] | null;
    entitySourceType: string;
}

interface ActivityResponse {
    topActiveUsers: ActivityEntity[] | null;
    topActiveResources: ActivityEntity[] | null;
    topDeniedUsers: ActivityEntity[] | null;
    topDeniedResources: ActivityEntity[] | null;
}

const useGetActivityData = ({ domainName, entitySourceType }: Params) => {
    const [data, setData] = useState<ActivityResponse>({
        topActiveUsers: null,
        topActiveResources: null,
        topDeniedUsers: null,
        topDeniedResources: null
    });
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const getActivityData = async () => {
            setIsFetching(true);
            setError(undefined);
            const localTimeZone = encodeURIComponent(jstz.determine().name());
            const url = `/insights/activity`;

            try {
                const response = (await httpGet(url, {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: {
                            domainName: domainName,
                            entitySourceType: entitySourceType,
                            localTimeZone: localTimeZone
                        }
                    }
                })) as unknown as HttpResponse<ActivityResponse>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get activity data');
            }

            setIsFetching(false);
        };

        getActivityData();
    }, [domainName, entitySourceType]);

    return { data, isFetching, error };
};

export { useGetActivityData };
